'use strict';
import {getId} from '../../../core-utilities/domain/ReduxUtils';
import {constructAssetProjectId} from '../../../projects/domain/ProjectDomain';


// Hydration Actions
const HYDRATE_ORGANIZATION = '@@app-model/HYDRATE_ORGANIZATION';
const HYDRATE_PROJECT = '@@app-model/HYDRATE_PROJECT';
const HYDRATE_ASSET = '@@app-model/HYDRATE_ASSET';

/**
 * Compares the current and previous state to determine the proper action to dispatch.
 * @param currentState
 * @param nextState
 * @param {Promise.defer} deferred
 * @return {ReduxAction} Returns the action corresponding to the delta of the current and next state.
 */
export function hydrateModel(currentState, nextState, deferred) {
  const userId = getId(currentState.user);
  const currentOrgId = getId(currentState.organization);
  const nextOrgId = getId(nextState.organization);
  const changeOrg = currentOrgId !== nextOrgId;

  const currentPrjId = getId(currentState.project);
  const nextPrjId = getId(nextState.project);
  const changePrj = currentPrjId !== nextPrjId;

  const currentAstId = getId(currentState.asset);
  const nextAstId = getId(nextState.asset);
  const changeAst = currentAstId !== nextAstId;

  const nextAssetProjectId = nextPrjId && nextAstId ? constructAssetProjectId(nextPrjId, nextAstId) : null;

  if (changeOrg) {
    return hydrateOrganization({
      userId,
      nextOrgId,
      nextPrjId,
      nextAstId,
      nextAssetProjectId,
      deferred,
    });
  } else if (changePrj) {
    return hydrateProject({
      nextPrjId,
      nextAstId,
      nextAssetProjectId,
      deferred,
    });
  } else if (changeAst) {
    return hydrateAsset({
      nextAstId,
      nextAssetProjectId,
      deferred,
    });
  } else {
    return null;
  }
}

/**
 *
 * @param {Object} data
 * @param {String} data.userId
 * @param {String} data.nextOrgId
 * @param {String} data.nextPrjId
 * @param {String} data.nextAstId
 * @param {String} data.nextAssetProjectId
 * @param {Promise.defer} [data.deferred]
 * @return {ReduxAction}
 */
export function hydrateOrganization(data = {}) {
  return {
    type: HYDRATE_ORGANIZATION,
    payload: {
      userId: data.userId,
      nextOrgId: data.nextOrgId,
      nextPrjId: data.nextPrjId,
      nextAstId: data.nextAstId,
      nextAssetProjectId: data.nextAssetProjectId,
      deferred: data.deferred,
    },
  };
}
hydrateOrganization.TYPE = HYDRATE_ORGANIZATION;

/**
 *
 * @param {Object} data
 * @param {String} data.nextPrjId
 * @param {String} data.nextAstId
 * @param {String} data.nextAssetProjectId
 * @param {Promise.defer} [data.deferred]
 * @return {ReduxAction}
 */
export function hydrateProject(data = {}) {
  return {
    type: HYDRATE_PROJECT,
    payload: {
      nextPrjId: data.nextPrjId,
      nextAstId: data.nextAstId,
      nextAssetProjectId: data.nextAssetProjectId,
      deferred: data.deferred,
    },
  };
}
hydrateProject.TYPE = HYDRATE_PROJECT;

/**
 *
 * @param {Object} data
 * @param {String} data.nextAstId
 * @param {String} data.nextAssetProjectId
 * @param {Promise.defer} [data.deferred]
 * @return {ReduxAction}
 */
export function hydrateAsset(data = {}) {
  return {
    type: HYDRATE_ASSET,
    payload: {
      nextAstId: data.nextAstId,
      nextAssetProjectId: data.nextAssetProjectId,
      deferred: data.deferred,
    },
  };
}
hydrateAsset.TYPE = HYDRATE_ASSET;



// WEBPACK FOOTER //
// ./src/js/app/model/actions/hydration.js